import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { SharedService } from "src/app/services/shared/shared.service";
import { EntityDinamica } from "src/app/entities/shared/EntityDinamica";
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { SelectionModel } from "@angular/cdk/collections";
import { Router } from "@angular/router";
import { sortInitPreviews } from "src/app/helpers/sort-utils";

@Component({
  selector: "app-previewDataTableFuente",
  templateUrl: "./previewDataTableFuente.component.html",
  styleUrls: ["./previewDataTableFuente.component.scss"],
  standalone: false
})
export class PreviewDataTableFuenteComponent implements OnInit, AfterViewInit {
  @Input() columnsNameDataTable: { columVar: string; columLabel: string }[];
  // Indica qué propiedad de la estructura usar para ordenar las columnas:
  // 'columnOrder' para Preview 1 y 'columnOrderTwo' para Preview 2.
  @Input() orderField: 'columnOrder' | 'columnOrderTwo' = 'columnOrder';
  domain: string;
  subdomain: string;

  @Input() mostrarCheckbox: boolean = true;

  private _dataTablaFuente: any[] = [];
  @Input() set dataTablaFuente(data: any[]) {
    // Validar que data sea iterable y no null/undefined
    if (data && Array.isArray(data)) {
      this._dataTablaFuente = [...data];
      this.dataBackup = [...data];
      // this.dataBackupTelco = [...data];
      this.filterDataSource();
      // console.log('data1 en app-previewDataTableFuente', data);
    } else {
      this._dataTablaFuente = [];
      this.dataBackup = [];
      this.filterDataSource();
    }
  }
  get dataTablaFuente(): any[] {
    return this._dataTablaFuente;
  }

  @Input() set textFilterTitle(textEvent: Event) {
    textEvent && this.applyFilter(textEvent);
  }
  @Input() set viewSoftDeleted(value: boolean) {
    this.displaySoftDelete = value;
    this.filterDataSource();
  }
  @Input() isTelco: boolean = false;
  @Input() ultAporteFhTelco: number = 0;
  @Input() source: any;
  @Input() defaultSortColumn: string;
  @Input() defaultSortDirection: 'asc' | 'desc' = 'asc';

  columnsNameDataTable2: { field: string; header: string, isSortable: boolean }[] = [];
  @Output() onColumSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCheckBoxSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDownloadDetailDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDataTablePaged: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChildren('inputRef') inputElements!: QueryList<ElementRef<HTMLInputElement>>;

  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<any[]>;
  selection = new SelectionModel<any[]>(true, []);

  dataBackup: EntityDinamica[] = [];
  displaySoftDelete: boolean = false;

  filtros: { [key: string]: string } = {};
  panelFilter: boolean = false;
  stateFilterSoftDelete: boolean = false;
  pageSize: number = 10;
  lastCheckedRowForShift: any | null = null;

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private sharedService: SharedService,
  ) {    // Inicializar dataSource con un array vacío para evitar null reference
    this.dataSource = new MatTableDataSource([]);
        this.localStorageService.getMenuSelectedObs.subscribe(menu => {
      if (menu) {
        const { domainJO, subDomainJO } = menu;
        this.domain = domainJO;
        this.subdomain = subDomainJO;
      }
      // console.log(" this.source ----->", this.domain, this.subdomain);
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    // if (!this.validSofdeleteFlow()) this.lastFilter();
    if (this.defaultSortColumn) {
      this.sort.active = this.defaultSortColumn;
      this.sort.direction = this.defaultSortDirection;
      this.sort.sortChange.emit();
    }
    // Proteger contra paginator undefined
    if (this.dataSource.paginator) {
      this.dataSource.paginator.page.subscribe(() => { this.emitDataPage(); });
    }
  }

  ngOnInit(): void {
    if (this.columnsNameDataTable && this.columnsNameDataTable.length > 0) {
      const estructuraFields = this.localStorageService.getEstructuraDinamicaField;

      if (estructuraFields && estructuraFields.length > 0) {
        this.columnsNameDataTable = this.sortColumnsByCustomOrder(
          [...this.columnsNameDataTable],
          estructuraFields
        );
      }
    }

    this.getColumVar();

    this.onCheckBoxSelect.emit(this.selection.selected);
    this.selection.changed.subscribe(() => {
      this.onCheckBoxSelect.emit(this.selection.selected);
    });

    this.localStorageService.currentStateFilter.subscribe(filter => {
      if (filter) {
        this.applyFilter(filter.event, filter.columVar);
      } else {
        this.filtros = {}
      }
    })
  }

  parseOrderValue(value: string | number | null | undefined): number | null {
    if (value === null || value === undefined) {
      return null;
    }
    if (typeof value === 'string' && value.trim() === "") {
      return null;
    }
    const num = parseFloat(String(value));
    return isNaN(num) ? null : num;
  }

  sortColumnsByCustomOrder(
    currentColumns: { columVar: string; columLabel: string }[],
    estructuraFields: any[]
  ): { columVar: string; columLabel: string }[] {
    const orderInfoMap = new Map<string, { order: number | null, originalEstructuraIndex: number }>();

    estructuraFields.forEach((field, index) => {
      const fieldIdentifier = field.name;
      // En Preview 2 se utiliza columnOrderTwo (con fallback a columnOrder por compatibilidad con datos antiguos).
      const columnOrderValue = this.orderField === 'columnOrderTwo'
        ? (field.columnOrderTwo ?? field.columnOrder)
        : field.columnOrder;

      if (fieldIdentifier) {
        orderInfoMap.set(fieldIdentifier, {
          order: this.parseOrderValue(columnOrderValue),
          originalEstructuraIndex: index
        });
      }
    });
    const sortableColumns = currentColumns.map((col, index) => {
      const sortData = orderInfoMap.get(col.columVar);
      return {
        ...col,
        sortOrder: sortData?.order,
        originalEstructuraIndex: sortData?.originalEstructuraIndex ?? Infinity,
        originalCurrentIndex: index
      };
    });

    sortableColumns.sort((a, b) => {
      const aHasValidOrder = a.sortOrder !== null;
      const bHasValidOrder = b.sortOrder !== null;

      if (aHasValidOrder && bHasValidOrder) {
        if (a.sortOrder !== b.sortOrder) {
          return (a.sortOrder as number) - (b.sortOrder as number);
        }
        return a.originalEstructuraIndex - b.originalEstructuraIndex;
      } else if (aHasValidOrder) {
        return -1;
      } else if (bHasValidOrder) {
        return 1;
      }
      return a.originalCurrentIndex - b.originalCurrentIndex;
    });

    return sortableColumns.map(({ columVar, columLabel }) => ({ columVar, columLabel }));
  }

  validSofdeleteFlow(): boolean {
    this.stateFilterSoftDelete = this.router.url.includes('seguimiento-reqid')
    return this.stateFilterSoftDelete;
  }

  emitDataPage() {
    const startIndex = this.paginator?.pageIndex * this.paginator?.pageSize;
    const endIndex = startIndex + this.paginator?.pageSize;
    const dataEmit = this.dataSource?.data.slice(startIndex, endIndex);
    this.onDataTablePaged.emit(dataEmit);
  }

  changeDataSelect(dataSource) {
    dataSource.forEach((fieldData) => {
      let dataObject = Object.keys(fieldData);

      dataObject.forEach((keyData) => {
        const selectInclude = keyData.includes("_select");
        if (selectInclude) {
          const rep = keyData.replace("_select", "");
          const index = this.columnsNameDataTable.findIndex(
            (index) => index.columVar === rep
          );
          if (index !== -1) {
            this.columnsNameDataTable[index].columVar = keyData;
          }
        }
      });
    });
  }

  onSelectData(data: any) {
    // console.log("onSelectData --->", data);
    // this.applyFilter(data.event,data.columVar);
  }

  setDataSource(dataSource) {
    // Validar que dataSource sea iterable
    const validData = (dataSource && Array.isArray(dataSource)) ? dataSource : [];
    this.dataSource = new MatTableDataSource(validData);

    // Solo asignar paginator y sort si están inicializados (después de ngAfterViewInit)
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }

    this.emitDataPage();
  }

  sortTypeInput(methodSort, dataSource) {
    let dataSort = [];
    const isPreview2 = this.orderField === 'columnOrderTwo';
    const fieldsSort = isPreview2 ? (methodSort.fieldsSortTwo || methodSort.fieldsSort) : methodSort.fieldsSort;
    const typeSort = isPreview2 ? (methodSort.typeSortTwo || methodSort.typeSort) : methodSort.typeSort;

    const struct = this.localStorageService.getEstructuraDinamicaField;

    const findSort = struct.find(field => field.name === fieldsSort);

    if (findSort) {
      let typeFields = "string";
      const { type, inputType } = findSort;
      const typeNumber = ['int', 'double', 'number'];
      if ((type === "string" || type === "int") && inputType === "date") {
        typeFields = "date";
      } else if ((typeNumber.some(item => item === type.toLowerCase()) && (inputType === "text" || inputType === "number"))) {
        typeFields = "number";
      }
      dataSort = sortInitPreviews(fieldsSort, typeSort, typeFields, dataSource);
    } else {
      dataSort = sortInitPreviews(fieldsSort, typeSort, "date", dataSource);
    }
    return dataSort;
  }

  getVisibleRows() {
    const startIndex = this.paginator?.pageIndex * this.paginator?.pageSize;
    return this.dataSource.filteredData.slice(startIndex, startIndex + this.paginator?.pageSize)
  }

  handleRowCheckboxClick(event: MouseEvent, clickedRow: any): void {
    event.stopPropagation();

    if (this.disableCheckbox(clickedRow)) {
      return;
    }

    const allRowsForSelection = this.dataSource.filteredData;

    if (event.shiftKey && this.lastCheckedRowForShift) {
      const lastIndex = allRowsForSelection.indexOf(this.lastCheckedRowForShift);
      const currentIndex = allRowsForSelection.indexOf(clickedRow);

      if (lastIndex === -1 || currentIndex === -1) {
        setTimeout(() => {
          if (this.selection.isSelected(clickedRow) && !this.disableCheckbox(clickedRow)) {
            this.lastCheckedRowForShift = clickedRow;
          } else if (this.lastCheckedRowForShift === clickedRow) {
            this.lastCheckedRowForShift = null;
          }
        }, 0);
        return;
      }

      setTimeout(() => {
        const start = Math.min(lastIndex, currentIndex);
        const end = Math.max(lastIndex, currentIndex);
        for (let i = start; i <= end; i++) {
          const rowToSelect = allRowsForSelection[i];
          if (rowToSelect && !this.disableCheckbox(rowToSelect)) {
            this.selection.select(rowToSelect);
          }
        }
      }, 0);

    } else {
      setTimeout(() => {
        if (this.selection.isSelected(clickedRow)) {
          this.lastCheckedRowForShift = clickedRow;
        } else {
          if (this.lastCheckedRowForShift === clickedRow) {
            this.lastCheckedRowForShift = null;
          }
        }
      }, 0);
    }
  }

  getColumVar() {
    if (this.mostrarCheckbox) {
      this.displayedColumns.push("select");
    }
    this.columnsNameDataTable.forEach(
      (column: { columVar: string; columLabel: string }) => {
        this.displayedColumns.push(column.columVar)
        const dataColumn = { field: column.columVar, header: column.columLabel, isSortable: true }
        this.columnsNameDataTable2.push(dataColumn);
      }
    );

    this.localStorageService.setColumnsFilter = this.columnsNameDataTable;
    this.localStorageService.setColumnsFilter2 = this.columnsNameDataTable2;
    if (!this.mostrarCheckbox) {
      this.displayedColumns.push("update");
      // this.displayedColumns.push("downloadDetail");
    }
    // console.log("this.displayedColumns getColumVar--->", this.displayedColumns);
  }

  applyFilter(event: Event, campo?: string) {
    const filterValue = (event.target as HTMLInputElement)?.value;

    if (campo) {
      this.filtros[campo] = filterValue?.trim().toLowerCase();
    }

    // Verifica si hay algún valor de filtro no vacío
    const hayFiltros = Object.values(this.filtros).some(
      (filtro) => filtro !== undefined && filtro !== ""
    );

    if (hayFiltros) {
      this.localStorageService.setFilter = this.filtros;
      this.localStorageService.setSourcePrevius = this.source;
    }

    // Configura el filtroPredicate para considerar todos los campos
    this.filtersPredicater();

    // Aplica el filtro acumulado o restablece a la data original si no hay filtros
    this.dataSource.filter = hayFiltros ? JSON.stringify(this.filtros) : "";
    this.selection.clear();
    // Proteger contra paginator undefined
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  isAllSelected(): boolean {
    // Proteger contra dataSource o filteredData undefined
    if (!this.dataSource || !this.dataSource.filteredData) {
      return false;
    }
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.filter(row => !this.disableCheckbox(row)).length;
    return numSelected === numRows && numRows > 0;
  }

  toggleAllRows(isChecked: boolean): void {
    if (!this.dataSource || !this.dataSource.filteredData) {
      return;
    }
    if (isChecked) {
      const allRowsToSelect = this.dataSource.filteredData.filter(row => !this.disableCheckbox(row));
      this.selection.select(...allRowsToSelect);
    } else {
      this.selection.clear();
    }
  }

  checkedHeader(selection1: any) {
    return (selection1.hasValue() && this.isAllSelected());
  }

  indeterminateHeader(selection1: any) {
    return (selection1.hasValue() && !this.isAllSelected());
  }

  clickRow($event2: any) {
    return ($event2.stopPropagation());
  }

  changeRow($event2: any, selection2: any, row2: any) {
    return ($event2 ? selection2.toggle(row2) : null);
  }

  checkedRow(selection2: any, row2: any) {
    return (selection2.isSelected(row2) && row2?.recordAction !== 'SOFT_DELETE');
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1
      }`;
  }

  lenghtData() {
    return this.dataSource?.data.length | 0;
  }

  filterDataSource() {
    // console.log('this.dataBackup', this.dataBackup);
    // console.log('this.displaySoftDelete', this.displaySoftDelete);
    let dataFiltradaSoftDelete = [];

    // Proteger contra dataBackup null/undefined
    if (!this.dataBackup || !Array.isArray(this.dataBackup)) {
      this.setDataSource([]);
      return;
    }

    if (!this.displaySoftDelete) {
      this.dataBackup.forEach((data) => {
        if (data.recordAction !== "SOFT_DELETE") {
          dataFiltradaSoftDelete.push(data);
        }
      });
    } else {
      dataFiltradaSoftDelete = this.dataBackup;
    }

    let dataFiltradaFinal = dataFiltradaSoftDelete;
    const header = this.localStorageService.dataEstructuraDinamicaHeader;

    if (header && header.hasOwnProperty("methodSort") && header.methodSort !== null && this.dataBackup && this.dataBackup.length > 0) {
      const { methodSort } = header;
      dataFiltradaFinal = this.sortTypeInput(methodSort, dataFiltradaFinal);
    }

    this.setDataSource(dataFiltradaFinal);
  }

  disableCheckbox(row?): boolean {
    const permission = this.localStorageService.configInit['F_DELETE_A'];
    const countryCode = this.localStorageService.getRegionSeleccionada?.getCode()?.toUpperCase();
    const isSicomMicro = this.domain === 'EC_CREDIT' &&
      (this.subdomain === 'SICOM_SUMMARY' || this.subdomain === 'MICROFINANCE');
    const isAllowedCountry = countryCode === 'SV' || countryCode === 'HN';
    const checkRowVip = this.localStorageService.getIsVip && !isSicomMicro && !isAllowedCountry;

    return (
      !this.sharedService.parseRolesArray(permission).includes(
        this.localStorageService.getPermissionCountry.roles
      ) || row?.recordAction === "SOFT_DELETE" || checkRowVip
    );
  }

  paintColor(row?: any): string {
    if (row.recordAction === 'SOFT_DELETE') {
      return 'seguimientoReqid';
    }
    if (this.isTelco && this.ultAporteFhTelco && row.info_fh == this.ultAporteFhTelco) {
      return 'telcoUltAporte';
    }
    return '';
  }

  lastFilter() {
    // console.log("cambio de dominio", this.source)
    localStorage.setItem("rdsCollection", this.source)
    if (this.source !== this.localStorageService.getSourcePrevius) {
      this.localStorageService.setFilter = undefined;
      this.localStorageService.setPageSize = null;
    } else {
      if (this.localStorageService.getFilter) {
        const filterStorage = this.localStorageService.getFilter;
        this.filtros = filterStorage;

        this.inputElements.forEach((element, index) => {
          const filterValue = filterStorage[element.nativeElement.id];
          if (filterValue) {
            element.nativeElement.value = filterValue;
          }
        });
        this.filtersPredicater();
        this.dataSource.filter = JSON.stringify(this.filtros);
        this.dataSource.paginator.firstPage();
      }

      const pageSize: any = this.localStorageService.getPageSize;

      if (pageSize !== null) {
        const data = {
          pageSize
        }
        this.onPageEvent(data);
      }
    }
  }

  filtersPredicater() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return Object.keys(this.filtros).every((campo) => {
        return data[campo]
          ?.toString()
          .toLowerCase()
          .includes(this.filtros[campo]);
      });
    };
  }

  onPageEvent(event) {
    if (event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.localStorageService.setPageSize = this.pageSize;
      this.localStorageService.setSourcePrevius = this.source;
    }
  }

  public clearSelection(): void {
    if (this.selection) {
      this.selection.clear();
    }
    this.lastCheckedRowForShift = null;
  }

}
